<template>
  <div
    :class="name"
    class="swatch p2">
    <h3 class="m0">{{ name }}</h3>
    <div v-if="hex"><strong>Hex:</strong> {{ hex }}</div>
    <div v-if="rgb"><strong>RGB:</strong> {{ rgb }}</div>
    <div v-if="hsla"><strong>HSLA:</strong> {{ hsla }}</div>
    <div v-if="cmyk"><strong>CMYK:</strong> {{ cmyk }}</div>
    <div v-if="pms"><strong>PMS:</strong> {{ pms }}</div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    hex: {
      type: String,
      default: ''
    },
    rgb: {
      type: String,
      default: ''
    },
    hsla: {
      type: String,
      default: ''
    },
    cmyk: {
      type: String,
      default: ''
    },
    pms: {
      type: String,
      default: ''
    }
  }
}
</script>
